/**
 * HEIC/HEIF decode via libheif-js (dynamically imported — the wasm bundle is
 * only fetched when a HEIC file is actually added). libheif applies irot/imir
 * transforms internally, so the output is already display-oriented.
 */
import { bitmapFromImageData } from './preview';

/* eslint-disable @typescript-eslint/no-explicit-any */
async function loadLibheif(): Promise<any> {
  const mod: any = await import('libheif-js/wasm-bundle');
  const raw = mod?.default ?? mod;
  const lib = typeof raw === 'function' ? await raw() : raw;
  if (!lib?.HeifDecoder) throw new Error('libheif HeifDecoder unavailable');
  return lib;
}

export async function decodeHeic(file: Blob): Promise<ImageBitmap> {
  const lib = await loadLibheif();
  const buffer = new Uint8Array(await file.arrayBuffer());
  const decoder = new lib.HeifDecoder();
  const images = decoder.decode(buffer);
  if (!images || images.length === 0) throw new Error('No images in HEIC');
  const image = images[0];
  const width: number = image.get_width();
  const height: number = image.get_height();
  const imageData = new ImageData(width, height);
  await new Promise<void>((resolve, reject) => {
    image.display(imageData, (result: ImageData | null) => {
      if (result) resolve();
      else reject(new Error('HEIC display failed'));
    });
  });
  return bitmapFromImageData(imageData);
}
